export default __webpack_public_path__ + "static/media/ICONS02.57b8b91f.svg";